import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { ScrollerModule } from "primeng/scroller";
import { InputTextModule } from "primeng/inputtext";
import { Popover, PopoverModule } from "primeng/popover";
import { DropdownModule } from "primeng/dropdown";

@UntilDestroy()
@Component({
  selector: "jni-header-customer-account",
  imports: [
    TableModule,
    ScrollerModule,
    PopoverModule,
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
  ],
  templateUrl: "./header-customer-account.component.html",
  styleUrls: ["./header-customer-account.component.scss"],
})
export class HeaderCustomerAccountComponent implements OnInit {
  public customerVendor$ = new Subject<string>();
  customerLists: ClientSearchList[] = [];
  showSmallLoader = false;

  customerBillToObject!: ClientSearchList;
  customerAccountNumber = "";
  selectedAccountNumber = "";

  projectId!: string;
  userObject!: GetUserDto;

  @Input() parent!: FormGroup;
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Output() customerBillToObjectEvent = new EventEmitter();
  @Output() bcSelectionForProspectEvent = new EventEmitter();
  @Output() getAllBuyersIfClientAccountEvent = new EventEmitter<string>();
  @Output() smallLoaderEvent = new EventEmitter<boolean>();
  @Input() formErrors!: Record<string, string>;
  @Output() validationErrorEvent = new EventEmitter();
  @Output() clearShipToEvent = new EventEmitter();
  @Output() selectedClientCurrenyEvent = new EventEmitter<string>();

  constructor(
    private _customerAccountService: CustomerAccountService,
    private _createHeaderQuoteService: CreateHeaderQuoteService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService
  ) {}
  ngOnInit(): void {
    this.searchCustomerName();
    const customerAccount = this.parent.get("orderHeader.customerId")?.value;
    if (customerAccount) {
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(customerAccount)
        .subscribe(res => {
          if (res?.data && res.data?.length > 0) {
            const clientObj = res.data[0];
            this.selectedAccountNumber = clientObj.clientAccount;
            this.clearInvoiceEmails();
            this.patchValueInCustomerAccount(this.selectedAccountNumber);
            this.customerBillToObject = clientObj;
            this.customerBillToObjectEvent.emit(this.customerBillToObject);
            if (clientObj.clientAccount != "") {
              this.deliveryAddress[1].status = false;
              this.deliveryAddress[2].status = false;
            } else {
              this.deliveryAddress[1].status = true;
              this.deliveryAddress[2].status = true;
            }
            this.patchValueInCustomerNameAndTelephoneField(clientObj);
            this.patchValueInCustomerAccountField(clientObj);
            this.patchValueInCustomerAddressField();
          }
        });
    }
  }
  onCustomerSearchOpenToggle(
    mydrop: Popover,
    event: Event,
    target: HTMLElement
  ) {
    const eventTarget = event.target as HTMLInputElement;
    mydrop.show(event, target);
    if (eventTarget.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  searchCustomerName() {
    this.customerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.smallLoaderEvent.emit(true);
          }
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._createHeaderQuoteService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<ClientSearchList[]>) => {
          if (res.data != null) {
            //const customerList = res.data;
            // this.customerLists = customerList.filter(
            //   (x: any) => x.clientType.toLowerCase() === 'client'
            // );
            this.customerLists = res.data;
          }
          this.smallLoaderEvent.emit(false);
        },
        error: () => {
          this.smallLoaderEvent.emit(false);
        },
      });
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    this.selectedAccountNumber = event.clientAccount;
    this.selectedClientCurrenyEvent.emit(event.currencyD365);
    this.clearInvoiceEmails();
    this.patchValueInCustomerAccount(this.selectedAccountNumber);
    this.customerBillToObject = event;
    this.customerBillToObjectEvent.emit(this.customerBillToObject);
    this.getAllBuyersIfClientAccountEvent.emit(this.selectedAccountNumber);
    if (event.clientAccount != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }

    this.patchValueInCustomerNameAndTelephoneField(event);
    this.patchValueInCustomerAccountField(event);
    this.patchValueInCustomerAddressField();
    clientProspetToggle.toggle(false);
    // if (this.customerBillToObject.clientType.toLowerCase() === 'prospect') {
    //   this.getUserProfile();
    // }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userObject = res.data;
          this.projectId = res?.data?.projectId ?? "";
          this.parent.patchValue({
            orderHeader: {
              brandingConsultant: this.projectId,
            },
          });
          this.bcSelectionForProspectEvent.emit(res.data);
        }
      },
    });
  }

  patchValueInCustomerAccount(accountNumber: string) {
    this.parent.patchValue({
      orderHeader: {
        customerId: accountNumber,
        customerIdValid: accountNumber,
      },
    });
  }

  patchValueInCustomerAddressField() {
    this._customerAccountService
      .getCustomerAddressByPartyNumber(
        this.customerBillToObject?.partyNumber,
        this.customerBillToObject?.clientAccount
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInCustomerFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          } else {
            this.patchValuesInCustomerFormAddressField("");
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getCustomerAccount(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const target = event.target as HTMLInputElement;
    const KeyboardEvent = event as KeyboardEvent;
    if (KeyboardEvent.key.toLowerCase() == "tab") {
      const countryValue = target.value;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(countryValue)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.customerLists = res.data;
            if (this.customerLists.length > 0) {
              this.onClientSelection(this.customerLists[0], mydrop);
              //this.clearShipToEvent.emit();
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  patchValueInCustomerNameAndTelephoneField(clientObj: ClientSearchList) {
    this.parent.patchValue({
      customerAddress: {
        name: clientObj.organizationNameD365,
        telephone: clientObj.locator === null ? "" : clientObj.locator,
        billingLocationD365: clientObj.billingLocationD365,
        billingAttentionD365: clientObj.billingAttentionD365,
      },
    });
  }

  patchValueInCustomerAccountField(clientObj: ClientSearchList) {
    this.parent.patchValue({
      orderHeader: {
        accountNumberD365: clientObj.clientAccount,
      },
    });
  }

  clearClearForm() {
    this.parent.patchValue({
      customerAddress: {
        name: "",
        address: "",
        telephone: "",
        billingLocationD365: "",
        billingAttentionD365: "",
      },
    });
  }

  patchValuesInCustomerFormAddressField(address: string) {
    this.parent.patchValue({
      customerAddress: {
        address: address,
      },
    });
  }

  clearInvoiceEmails() {
    (this.parent.get("invoicedEmails") as FormArray).clear();
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }
}
